import React, {Component} from 'react';
import {Form, Modal, Button,message,DatePicker} from 'antd';	
import { connect } from 'react-redux';
import moment from 'moment';

import API from '@/API/api';
const FormItem = Form.Item;
const { RangePicker } = DatePicker;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};

class ExportTaskStatsModal extends Component{
	
	static contextTypes={
	    router: React.PropTypes.object.isRequired,
	}
	constructor(props) {
	    super(props);
	    this.state={
			btnLoading:false,
		}

    }
	componentDidMount(){
//		console.log(this.context.router)
	}
	disabledDate=(current)=> {
	  return current && current.valueOf() > Date.now();
	}
	handleSubmit = (e) => {
	    e.preventDefault();
	    this.props.form.validateFieldsAndScroll((err, values) => {
	      if (!err) {
			let params={
				start_time:values.daterange[0].toLocaleString(),
				end_time:values.daterange[1].toLocaleString()
			}
	        this.setState({btnLoading:true})
	        let form = $("<form>");   //定义一个form表单
            form.attr('style', 'display:none');   //在form表单中添加查询参数
            form.attr('target', '');
            form.attr('method', 'post');
            form.attr('action', API.EXPORT_BEYOND_TASK_STATS);
            let input1 = $('<input>').attr('type', 'hidden').attr('name', 'start_time').attr('value', params.start_time);
            let input2 = $('<input>').attr('type', 'hidden').attr('name', 'end_time').attr('value', params.end_time);
            $('body').append(form);  //将表单放置在web中
            form.append(input1);   //将查询参数控件提交到表单上
            form.append(input2);
            form.submit();
           	message.success('导出成功！');
	      	this.setState({btnLoading:false})
	      	this.props.handleClose()
	      	this.props.form.resetFields();
	      }
	    });
	 }


	
	render(){
		let {btnLoading}=this.state
		let {openExport,handleClose}=this.props
		const { getFieldDecorator } = this.props.form;
		const filedOption={
			daterange:{rules: [{ type: 'array',required: true, message: '必填项!', whitespace: true }]}
		}
		
		return(
			<Modal
	          title="任务统计导出"
	          visible={openExport}
	          onCancel={handleClose}
	          footer={[
	            <Button key="cancel"  onClick={handleClose}>取消</Button>,
	            <Button key="save" type="primary"  loading={btnLoading} onClick={this.handleSubmit}>确定</Button>,
	          ]}
	        >
				<Form >
					<FormItem {...formItemLayout} label="起止时间" hasFeedback>
						{getFieldDecorator(`daterange`, filedOption.daterange)(
					          	<RangePicker disabledDate={this.disabledDate} />
					     )}
					</FormItem>
				</Form >
			 </Modal>
		)
	}
}


export const WrappedExportTaskStatsForm = Form.create()(ExportTaskStatsModal)



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/check_beyond_level/modal/export_task_stats.js